import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { qrCode } from '../../redux/slice/QRCode';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Loader from '../../components/loader/Loader';
import { toast } from 'react-toastify';
import { biolinkQRCode } from '../../redux/slice/BiolinkQRCode';

export default function BiolinkQRCode(props) {
    const { qrShow, setQRShow, qrCode } = props
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const qrCodeImage = useSelector((state) => state.biolinkQRCode.data?.[0])

    // const bio_link_url = localStorage.getItem('profile_url')+localStorage.getItem('user_name')
    const bio_link_url2 = `x/${localStorage.getItem('user_name')}`
    const user_url = qrCode?.user ? qrCode?.user?.user_name : qrCode?.user_name

    useEffect(() => {
        setLoading(true)
        const baseUrl = (process.env.REACT_APP_BASE_URL || 'https://ad1.page').replace(/\/$/, '');
        dispatch(biolinkQRCode({ biolink_url: qrCode ? `${baseUrl}/x/${user_url}` : `${baseUrl}/x/${localStorage.getItem('user_name')}`, navigate })).finally(() => setLoading(false))
        // dispatch(biolinkQRCode({ biolink_url: bio_link_url, navigate })).finally(() => setLoading(false))
    }, [qrShow])

    const handleDownload = async () => {
        if (!qrCodeImage?.qr_code_url) {
            toast.error('QR code image not available');
            return;
        }

        try {
            const response = await fetch(qrCodeImage.qr_code_url);
            if (!response.ok) {
                throw new Error('Failed to fetch QR code image');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `qrcode-${qrCode ? user_url : bio_link_url2 || 'qr'}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            toast.success('QR code downloaded successfully!', { position: "bottom-right" });
        } catch (error) {
            console.error('Error downloading QR code:', error);
            toast.error('Failed to download QR code. Please try again.', { position: "bottom-right" });
        }
    };

    return (
        <>

            <Modal
                size="md"
                show={qrShow}
                centered
                onHide={() => setQRShow(false)}
                aria-labelledby="example-modal-sizes-title-md"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-md">
                        QR Code
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        loading ?
                            <Loader />
                            :
                            <div className='text-center'>
                                <img
                                    src={qrCodeImage?.qr_code_url}
                                    alt="QR Code"
                                    style={{ width: 300, height: 300 }}
                                />
                                <button
                                    style={{ width: '100%', marginTop: '15px' }}
                                    className='btn btn-secondary'
                                    onClick={handleDownload}
                                    disabled={!qrCodeImage?.qr_code_url}
                                >
                                    DOWNLOAD
                                </button>
                            </div>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
